import { Observable } from 'rxjs';
import { PrizeBox } from '../client-area/client-area.models';

export enum ChargeBackStatus {
    ACTIVE = 1,
    CLAIM = 3
}

export type UserChargebackResponse = {
    active: UserChargeback | Observable<UserChargeback>,
    toClaim?: UserChargeback
}

export type UserChargeback = {
    win: number,
    lost: number,
    ggr: number,
    value: number
    name: string,
    payoutDate: string,
    chargebackUID: string,
    convertedDate?: Date,
    currency: string,
    status: ChargeBackStatus,
    isToClaim?: boolean
    resolved?: boolean
}

export type ActiveChargeback = {
    name: string,
    payoutDate: string,
    convertedDate?: Date
}

export interface UserGamificationLevel {
    gamificationReference: string
    levelNumber: number
    turnover: number
    levelEndsTurnover: number
}

export interface UserBonusLottery {
    isActive: boolean
    uid: string
    leftToOpen: number,
    prizeBoxes: PrizeBox[]
    crossSell?: string
    crossSellAffiliateSegment?: string
    crossSellBonusConfigName?: string
}

export enum LimitType {
    deposit = "deposit",
    wager = "wager",
    lost = "lost",
    game_session_time = "game_session_time"
}

export interface LimitEntry {
    sum: number,
    type: LimitType,
    period: string,
    value: number,
    created?: string
}

export interface LimitsResponse {
    has_parallel_limits: boolean
    limits: LimitEntry[]
    country: string,
    currency: string,
}

export interface TopGames {
    maxWin: string[],
    totalRounds: string[]
}

export interface MostPlayedGameStatistic {
    externalId: string,
    uniquePlayers: number
}

// --- Safe Play API Models - Start --- //
export interface BaseAPIResponse {
    response_status_code: number;
    success: boolean;
}

export interface APICoolingOffPostResponse extends BaseAPIResponse {
    is_cooling_off: boolean;
    cooling_off_until: string;
    marketing_opt_out: boolean;
}

export interface APISelfExclusionPostResponse extends BaseAPIResponse {
    is_self_exclusion_uk_license: boolean;
}

export interface APIRequest {
    time: number | string;
    reason?: string;
    source?: string;
    product_type?: string;
    marketing_opt_out?: boolean;
}

export interface BlockPeriod {
    key: number | 'permanent';
    name: string;
}

export interface APISelfExclusionResponse {
    is_self_excluded: boolean | null;
    is_uk: boolean;
    block_periods: {
        'self-exclusion': BlockPeriod[];
    };
    self_exclusion: RestrictionPeriodDetails;
}

export interface APICoolingOffResponse {
    is_cooling_off: boolean;
    marketing_opt_out: boolean;
    block_periods: {
        'cooling-off': BlockPeriod[];
    };
    cooling_off: RestrictionPeriodDetails;
}

export interface RestrictionPeriodDetails  {
    until: string;
    period: number;
    name: string;
}

// --- Safe Play API Models - End --- //
